import type { SupabaseClient } from '@supabase/supabase-js';

// syncSessionToServer lives in src/data/authApi.ts with the other auth calls; re-exported here
// so existing importers keep working.
export { syncSessionToServer } from '@/data/authApi';

/**
 * After Worker `/api/auth/callback`, Supabase may only persist the session in
 * SSR cookies. The browser `createClient` (localStorage) then has no session
 * until we mirror tokens from `/api/auth/session` into the JS client via
 * `setSession` (see `functions/api/auth/session.ts` response shape).
 */
export async function hydrateSessionFromWorkerCookies(sb: SupabaseClient): Promise<boolean> {
  try {
    const res = await fetch('/api/auth/session', { credentials: 'include' });
    if (!res.ok) return false;
    // OBS-11 a-ignore: an unparseable body becomes null, which the !ok / missing-field check right after handles.
    const json = (await res.json().catch(() => null)) as {
      session?: { access_token?: string; refresh_token?: string } | null;
    } | null;
    const access = json?.session?.access_token;
    const refresh = json?.session?.refresh_token;
    if (!access || !refresh) return false;
    const { error } = await sb.auth.setSession({ access_token: access, refresh_token: refresh });
    return !error;
  } catch {
    return false;
  }
}
